import { inject, Injectable } from '@angular/core';
import { SessionService } from 'src/app/auth/session.service';
import { AdditionalCustomValidation } from './multiple-custom-form-field.enum';

@Injectable()
export class ItemValidationService {
  private sessionService = inject(SessionService);

  public itemValidationCheck(
    selectedItems: string[],
    item: string,
    validationParam?: AdditionalCustomValidation,
  ): boolean {
    const isValidBasicValidation: boolean = this.basicValidation(selectedItems, item);
    const isValidAdditionalValidation: boolean = validationParam
      ? this.getAdditionalValidation(item, validationParam)
      : true;

    return isValidBasicValidation && isValidAdditionalValidation;
  }

  public basicValidation(selectedItems: string[], item: string): boolean {
    return Boolean(item) && selectedItems.length < 10 && !this.getUniqueItem(selectedItems, item);
  }

  public getUniqueItem(selectedItems: string[], item: string): boolean {
    return selectedItems.some((selectedItem: string) => selectedItem === item);
  }

  public getAdditionalValidation(item: string, validationParam: AdditionalCustomValidation): boolean {
    switch (validationParam) {
      case AdditionalCustomValidation.ORGANIZATION_NAME:
        return item !== this.sessionService.user.displayed_name;
      default:
        return true;
    }
  }
}
